import { render } from "./ProductCardSolutions.vue?vue&type=template&id=1ae7a400"
import script from "./ProductCardSolutions.vue?vue&type=script&lang=js"
export * from "./ProductCardSolutions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__